import { useWebsiteSettings } from 'client/store'
import { getWebsiteDomain } from 'src/editor/store/website-settings/website-settings-selector'
import { isSystemeDomain } from 'src/shared/utils/is-systeme-domain'
import { shouldShowRegistrationButtonInWebsiteHeader } from 'src/shared/utils/website-header-utils'

export const useShouldShowRegistrationButtonInWebsiteHeader = (): boolean => {
  const websiteDomain = useWebsiteSettings(getWebsiteDomain)
  const isWhiteLabel = websiteDomain?.isWhiteLabel === true
  const isSystemeWebsiteDomain =
    !websiteDomain?.name || isSystemeDomain(websiteDomain.name)

  return shouldShowRegistrationButtonInWebsiteHeader(
    isWhiteLabel,
    isSystemeWebsiteDomain,
  )
}
